module.exports = __webpack_public_path__ + "static/pokoj-nr5-photo03-0a0180df0fe010436ad015c18f7c14b8.jpg";